import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import { pxToVw } from '@/modules/styled/cssUnits';
import styled from 'styled-components';

export const StyledSearchThemes = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${pxToVw(30)};

  .pointer {
    cursor: pointer;
  }

  .left-content {
    display: flex;
    flex: 1;
  }

  @media only screen and (max-width: ${MediaQueryBreakpoints.md}) {
    flex-direction: column;
    gap: 30px;

    .left-content {
      display: none;
    }
  }
`;
